import { Injectable } from '@angular/core';
import * as html2canvas from 'html2canvas';


@Injectable()
export class ExportKmlService {


    getDocumentContent(content: string, name: string) {
        return `<?xml version="1.0" encoding="UTF-8"?>\n` +
                `<kml xmlns="http://www.opengis.net/kml/2.2">\n` +
                `  <Document>\n` +
                `    <name>${name}</name>\n` +
                `${content}` +
                `  </Document>\n` +
                `</kml>\n`
    }

    // USADO APENAS EM POSITION BY FENCES
    buildKMLPolylineStyleTag(polylines) {
        let result = ''
        polylines.map((polyline) => {
            if (polyline.route != undefined) {
                result +=   `    <Style id="${polyline.id}">\n` +
                            `      <LineStyle>\n` +
                            `        <color>${polyline.color}</color>\n` +
                            `        <width>${polyline.width}</width>\n` +
                            `      </LineStyle>\n` +
                            `      <LabelStyle>\n` +
                            `        <color>${polyline.color}</color>\n` +
                            `      </LabelStyle>\n` +
                            `    </Style>\n`
            }
        }).join('')
        return result
    }

     /** METODO GENERICO PARA CONSTRUIR A TAG STYLE */
    getPolylineStyle(polylines) {
        let result = ''
        polylines.map((polyline) => {
            if (polyline.route != undefined) {
                result +=   `    <Style id="${polyline.id}">\n` +
                            `      <LineStyle>\n` +
                            `        <color>${this.colorFormater(polyline.route.options.color.replace('#', ''))}</color>\n` +
                            `        <width>${polyline.route.options.weight + 3}</width>\n` +
                            `      </LineStyle>\n` +
                            `    </Style>\n`
            }
        }).join('')
        return result
    }

    buildKMLFenceStyleTag(fences) {
        let result = ''
        fences.map((fence) => {
            result +=   `    <Style id="${fence.id}">\n` +
                        `      <LineStyle>\n` +
                        `        <color>${fence.fillColor}</color>\n` +
                        `        <width>${fence.width}</width>\n` +
                        `      </LineStyle>\n` +
                        `      <PolyStyle>\n` +
                        `        <color>${fence.borderColor}</color>\n` +
                        `      </PolyStyle>\n` +
                        `    </Style>\n`
        }).join('')
        return result
    }

    getPlacemarkPolylines(polylines) {
        let result = ''
        let description = ''
        polylines.forEach(polyline => {
            if (polyline.route != undefined) {
                const coordinates = []
                polyline.route._latlngs.forEach(latlng => {
                    coordinates.push([latlng.lng, latlng.lat])
                })
                if (polyline.popup) {
                    description = this.getDescription(polyline.popup)
                }

                result +=   `    <Placemark>\n` +
                            `      <name>${polyline.name}</name>\n` +
                            `      <styleUrl>#${polyline.id}</styleUrl>\n` +
                            `${description}` +
                            `      <LineString>\n` +
                            `        <tessellate>1</tessellate>\n` +
                            `        <coordinates>\n ${coordinates.map(coord => '          ' + coord + '\n').join(' ')}` +
                            `        </coordinates>\n` +
                            `      </LineString>\n` +
                            `    </Placemark>\n`
            }
        })
        return result
    }

    //USADO EM POSITIONS-BY-FENCES
    buildPositionMarkersStyleTag(iconList) {
        console.log('iconList', iconList)
        let result = ''
        iconList.map(icon => {
            result +=   `    <Style id="${icon.id}">\n` +
                        `      <IconStyle>\n` +
                        `        <color>${this.colorFormater(icon.color.replace('#', ''))}</color>\n` +
                        `        <Icon>\n` +
                        `          <href>` +
                        `            ${icon.icon}\n` +
                        `          </href>\n` +
                        `        </Icon>\n` +
                        `        <heading>${(icon.position.speed == 0 || (!icon.position.speed && icon.position.device_speed == 0)) ? 0 : icon.position.direction}</heading>\n` +
                        `        <scale>0.8</scale>\n` +
                        `      </IconStyle>\n` +
                        `      <LabelStyle>\n` +
                        `        <scale>${icon.labelScale}</scale>\n` +
                        `      </LabelStyle>\n` +
                        `    </Style>\n`
        }).join('')
        return result
    }

    buildKMLMarkerStyleTag(markers, scale) {
        let result = ''
        let heading = ''
        let color = ''
        markers.map(item => {
            if (item.heading) {
                heading = `        <heading>${item.heading}</heading>\n`
            }
            if (item.color != 'transparent') {
                color = `        <color>${this.colorFormater(item.color.replace('#', ''))}</color>\n`
            }
            result +=   `    <Style id="${item.id}">\n` +
                        `      <IconStyle>\n` +
                        `${color}` +
                        `        <Icon>\n` +
                        `          <href>` +
                        `            ${item.icon}\n` +
                        `          </href>\n` +
                        `        </Icon>\n` +
                        `${heading}` +
                        `        <scale>${scale}</scale>\n` +
                        `      </IconStyle>\n` +
                        `      <LabelStyle>\n` +
                        `        <scale>${item.labelScale}</scale>\n` +
                        `      </LabelStyle>\n` +
                        `    </Style>\n`
        }).join('')
        return result
    }

    // USADO EM POSITIONS BY FENCES
    buildPolylinesAndMarkersFolders(polyline) {
        const iconList = []
        let result = `    <Folder>\n`
        result += `      <name>${polyline.name}</name>\n`
        if (polyline.route != undefined) {
            const coordinates = []

            polyline.route._latlngs.forEach(latlng => {
                coordinates.push([latlng.lng, latlng.lat])
            })
            result +=   `      <Placemark>\n` +
                        `        <name>${polyline.name}</name>\n` +
                        `        <styleUrl>#${polyline.id}</styleUrl>\n` +
                        `        <LineString>\n` +
                        `          <tessellate>1</tessellate>\n` +
                        `          <coordinates>\n ${coordinates.map(coord => '          ' + coord + '\n').join(' ')}` +
                        `          </coordinates>\n` +
                        `        </LineString>\n` +
                        `      </Placemark>\n`
        }
        polyline.positions.map(positions => {
            iconList.push(positions)
        })
        result += this.buildPositionMarkersPlacemarkTag(iconList)
        result += `    </Folder>\n`
        return result
    }

    buildPositionMarkersPlacemarkTag(iconList) {
        let result = ''
        iconList.map((icon) => {
            if (icon.position != undefined) {
                result +=   `    <Placemark>\n` +
                            `      <name>${icon.name}</name>\n` +
                            `      <styleUrl>#${icon.id}</styleUrl>\n` +
                            `${this.getDescription(icon.popup)}` +
                            `      <Point>\n` +
                            `        <coordinates>${icon.position.lng},${icon.position.lat}</coordinates>\n` +
                            `      </Point>\n` +
                            `    </Placemark>\n`
            }
        }).join('')
        return result
    }

    getFolder(content, name) {
        let result = `    <Folder>\n`
        result += `      <name>${name}</name>\n`
        result += content
        result += `    </Folder>\n`
        return result
    }

    getDescription(infoObjectList) {
        let result = ''
        if (infoObjectList != undefined) {
            result = '      <description><![CDATA['
            infoObjectList.map(objectItem => {
                result += `<b>${objectItem.title}:</b> ${objectItem.data || '-'}<br><br>`
            })
            result += ']]></description>\n'
        }
        return result
    }

    // USADO EM POSITIONS BY FENCES
    buildKMLFencePlacemarkTag(fences) {
        let result = ''
        fences.map((fence) => {
            const coordinatesArray = fence.geojson.geometry.coordinates[0]
            coordinatesArray.map((coord: any) => coord.join(',')).join(' ')
            const coordinates = coordinatesArray

            result +=   `    <Placemark>\n` +
                        `      <name>${fence.name}</name>\n` +
                        `      <speedLimit>${fence.speedLimit}</speedLimit>\n` +
                        `      <styleUrl>#${fence.id}</styleUrl>\n` +
                        `      <description><![CDATA[<b>${fence.displayName}:</b> ${fence.speedLimit}km/h<br>]]></description>\n` +
                        `      <Polygon>\n` +
                        `        <outerBoundaryIs>\n` +
                        `          <LinearRing>\n` +
                        `            <coordinates>\n ${coordinates.map(coord => '             ' + coord + '\n').join(' ')}` +
                        `            </coordinates>\n` +
                        `          </LinearRing>\n` +
                        `        </outerBoundaryIs>\n` +
                        `      </Polygon>\n` +
                        `    </Placemark>\n`
        }).join('')
        return result
    }

    getScreenOverlay(detailsObjectList, name) {
        let result = ''
        result +=   `      <ScreenOverlay>\n` +
                    `        <name>${name}</name>\n`
        result += `  ${this.getDescription(detailsObjectList)}`
        result +=   `        <overlayXY x="0" y="1" xunits="fraction" yunits="fraction"/>\n` +
                    `        <screenXY x="0.5" y="1" xunits="fraction" yunits="fraction"/>\n` +
                    `      </ScreenOverlay>\n`
        return result
    }

    getCheckPointsScreenOverlayTag(detailsObjectList, name) {
        let result = ''
        result +=       `      <ScreenOverlay>\n` +
                        `        <name>${name}</name>\n`
        result +=       '        <description><![CDATA['
        detailsObjectList.map(detail => {
            result +=   `${detail.datetime}<br><i>${detail.interaction}</i><br><b>${detail.checkpointName}</b><br><br>`
        })
        result += ']]></description>\n'
        result +=   `        <overlayXY x="0" y="1" xunits="fraction" yunits="fraction"/>\n` +
                    `        <screenXY x="0.5" y="1" xunits="fraction" yunits="fraction"/>\n` +
                    `      </ScreenOverlay>\n`
        return result
    }

    getCheckpointsPlacemarkTag(checkpointMarkerList) {
        let result = ''
            checkpointMarkerList.map(checkpointMarker => {
                const description = this.getDescription(checkpointMarker.popup)
                result +=   `    <Placemark>\n` +
                            `      <name>${checkpointMarker.name}</name>\n` +
                            `      <styleUrl>#${checkpointMarker.id}</styleUrl>\n` +
                            `${description}` +
                            `      <Point>\n` +
                            `        <coordinates>${checkpointMarker.position.location.lng},${checkpointMarker.position.location.lat}</coordinates>\n` +
                            `      </Point>\n` +
                            `    </Placemark>\n`
            })
        return result
    }

    getPlacemarkMarkers(markerList) {
        let result = ''
        let description = ''
        let name = ''
            markerList.map(marker => {
                if (marker.popup) {
                    description = this.getDescription(marker.popup)
                }
                if (marker.name) {
                    name = `      <name>${marker.name}</name>\n`
                }
                result +=   `    <Placemark>\n` +
                            `${name}` +
                            `      <styleUrl>#${marker.id}</styleUrl>\n` +
                            `${description}` +
                            `      <Point>\n` +
                            `        <coordinates>${marker.position.lng},${marker.position.lat}</coordinates>\n` +
                            `      </Point>\n` +
                            `    </Placemark>\n`
            })
        return result
    }

    downloadKML(kml: string, fileName: string) {
        const blob = new Blob([kml], { type: 'application/vnd.google-earth.kml+xml' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `${fileName}.kml`
        a.click()
        window.URL.revokeObjectURL(url)
    }


    colorFormater(hexaColor) {
        if (hexaColor.length % 2 !== 0) {
            return
        }
        const pairs = hexaColor.match(/.{1,2}/g)
        return 'ff' + pairs[2] + pairs[1] + pairs[0]
    }
}

